"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AltairColorScheme = void 0;
const tabby_terminal_1 = require("tabby-terminal");
const core_1 = require("@angular/core");
let AltairColorScheme = class AltairColorScheme extends tabby_terminal_1.TerminalColorSchemeProvider {
    getSchemes() {
        return __awaiter(this, void 0, void 0, function* () {
            let theme = [];
            theme.push({
                name: "Altair",
                foreground: "#f3f4ef",
                background: "#22242d",
                cursor: "#b4b4ba",
                colors: [
                    "#22242d",
                    "#ff1654",
                    "#06d6a0",
                    "#ffe66d",
                    "#00abe7",
                    "#ff60b5",
                    "#7bdff2",
                    "#f9f9f9",
                    "#22242d",
                    "#ff1654",
                    "#06d6a0",
                    "#ffe66d",
                    "#00abe7",
                    "#ff60b5",
                    "#7bdff2",
                    "#f9f9f9",
                ],
            });
            return theme;
        });
    }
};
AltairColorScheme = __decorate([
    (0, core_1.Injectable)()
], AltairColorScheme);
exports.AltairColorScheme = AltairColorScheme;
